<app-dropdown [alignLeft]="alignLeft">
  <ng-container header>
    <div class="dropdown">
      <span class="dropdown__name">
        {{header}}
      </span>
      <i class="material-icons">expand_more</i>
    </div>
  </ng-container>
  <ng-container body>
    <div class="dropdown-body">
      <ng-content></ng-content>
    </div>
  </ng-container>
</app-dropdown>